import { IAuditorModel } from "./../../../models/alocar-equipe-component";
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ToastrService } from "ngx-toastr";
import { IOsaModelImprimir } from "src/app/models/osa-imprimir";
import { OsaService } from "src/app/services/osa.service";
import { BaseFormComponent } from "src/app/shared/components/base-form/base-form.component";
import Swal from "sweetalert2";
import { ILinhaDoTempoAvaliacaoModel } from "src/app/models/linha-tempo-avaliacao.model";
import { IBaseModel } from "../../../models/base.model";
import { IOpaModel } from "../../../models/opa.model";
import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { Parser } from "@angular/compiler";

@Component({
	selector: "app-osa-imprimir",
	templateUrl: "./osa-imprimir.component.html",
	styleUrls: ["./osa-imprimir.component.scss"],
})
export class OsaImprimirComponent extends BaseListComponent implements OnInit {
	public model: IOsaModelImprimir[] = [];

	consolidado = false;

	constructor(
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private router: Router,
		private localeService: BsLocaleService,
		private matDialog: MatDialog,
		private osaService: OsaService
	) {
		super();
	}

	ngOnInit(): void {
		let route = this.route.snapshot;
		while (route.firstChild) {
			route = route.firstChild;
		}
		const urlSegments = route.url;
		const lastSegment =
			urlSegments.length > 0
				? urlSegments[urlSegments.length - 1].path
				: "";

		if (lastSegment === "relatorio-consolidado") {
			this.consolidado = true;
		}

		this.buscar();
	}

	async buscar() {
		if (this.consolidado) {
			let res: IBaseModel<IOsaModelImprimir[]>;
			const ids = this.route.snapshot.paramMap.get("id") || "";
			res = await this.osaService.imprimirOpaConsolidado(ids);
			this.model = res.dados;
      console.log(res.dados);

		} else {
			const id = this.route.snapshot.paramMap.get("id") || "";
			this.osaService.getImprimir(parseInt(id, 10)).then((res) => {

				if (!res.sucesso) {
					this.exibirMensagemErro(res.mensagem.descricao);
				}
				this.model = Array.isArray(res.dados)
					? res.dados
					: res.dados
					? [res.dados]
					: [];
			});
		}

	}

  public getAssinaturasPorPapel(papel: string, osa: IOsaModelImprimir): any[] {
    if (!osa?.assinaturas) return [];

    return osa.assinaturas.filter(item =>
      item?.papel?.trim() === papel
    );
  }
	public print() {
		window.print();
	}

	public cancelar() {
		window.history.back();
	}
}
